module.exports = __webpack_public_path__ + "img/mini-music-sqaure.4b1bcca8.svg";